gsap.registerPlugin(ScrollTrigger, SplitText);

function initHighlightText() {
  const splitHeadingTargets = document.querySelectorAll('[data-highlight-text]');

  splitHeadingTargets.forEach((heading) => {
    const scrollStart =
      heading.getAttribute('data-highlight-scroll-start') || 'top 90%';
    const scrollEnd =
      heading.getAttribute('data-highlight-scroll-end') || 'center 40%';
    const fadedValue =
      parseFloat(heading.getAttribute('data-highlight-fade')) || 0.2;
    const staggerValue =
      parseFloat(heading.getAttribute('data-highlight-stagger')) || 0.1;

    new SplitText(heading, {
      type: 'words, chars',
      autoSplit: true,
      onSplit(self) {
        let ctx = gsap.context(() => {
          gsap.timeline({
            scrollTrigger: {
              scrub: true,
              trigger: heading,
              start: scrollStart,
              end: scrollEnd,
            },
          }).from(self.chars, {
            autoAlpha: fadedValue,
            stagger: staggerValue,
            ease: 'linear',
          });
        });

        return ctx;
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initHighlightText);